import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsRunNormalXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M6.03 13.29a7.45 7.45 0 005.28 2.21h2.19a2 2 0 00.3-3.98L9.96 4.33a1.747 1.747 0 00-2.443-.653c-.274.17-.495.414-.637.703l-.27.56a.873.873 0 01-.33-.8V2.17A1.3 1.3 0 004.97.75a1.433 1.433 0 00-1.34.93L2.16 4.67l-.95.7A1.819 1.819 0 00.5 6.74a1.942 1.942 0 00.6 1.53l4.93 5.02zM1.79 6.18l.4-.3 5.14 5.07h1.42l-5.77-5.7L4.54 2.1a.475.475 0 01.43-.35c.15 0 .31.04.31.42v1.97c0 1.13.63 1.87 1.61 1.87h.31l.58-1.19a.729.729 0 011.29-.02l.63 1.17-1.26.67v1.14l1.73-.92.41.78-1.34.71v1.14l1.82-.96.39.74-1.56.83v1.14l2.03-1.09 1.12 2.09.16.26h.3a1 1 0 010 2h-2.19a6.492 6.492 0 01-4.57-1.91L1.79 7.55a.96.96 0 01-.29-.75.87.87 0 01.29-.62z"
        fill=""
      />
    </svg>
  )
);
SvgSportsRunNormalXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgSportsRunNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsRunNormalXsmall;
